import type { ReactElement } from 'react';
import cx from 'clsx';
import { useIntl } from 'react-intl';
import { Label as AriaLabel, type LabelProps as AriaLabelProps } from 'react-aria-components';
import styles from './label.module.css';

interface FieldLabelProps extends AriaLabelProps {
  isOptional?: boolean;
}

export function FieldLabel({
  className,
  children,
  isOptional = false,
  ...props
}: FieldLabelProps): ReactElement {
  const intl = useIntl();
  return (
    <AriaLabel className={cx(className, 'body-standard', styles.label)} {...props}>
      {children} {isOptional ? intl.formatMessage({ id: 'form-elements-optional' }) : null}
    </AriaLabel>
  );
}
